import React, { useState } from "react";
import { Box, Grid } from "@material-ui/core";
import List from "../plants/ListPlants";
import DeviceContainer from "../../containers/device/DeviceContainer";
import ListPlantsContainer from "../../containers/plants/ListPlantsContainer";
import Create from "../plants/CreatePlant";
import Edit from "../plants/EditPlant";

const InstallerView = () => {
  const [openCreate, setOpenCreate] = useState(false);
  const [editItem, setEditItem] = useState(null);

  return (
    <>
      <Box p={2} mb="7%">
        <ListPlantsContainer>
          {({
            onUpdateRowsAndPages,
            onConnectDevice,
            content,
            item,
            onCloseDevice,
            updateStatus,
            date,
          }) => (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <List
                  onUpdateRowsAndPages={onUpdateRowsAndPages}
                  onConnectDevice={onConnectDevice}
                  items={content ? content : []}
                  ekloksStatus={updateStatus}
                  onAddAction={() => setOpenCreate(true)}
                  onEditPlant={(item) => setEditItem(item)}
                />
                {item ? (
                  <DeviceContainer
                    item={item}
                    onCloseDevice={onCloseDevice}
                    date={date}
                  />
                ) : null}
              </Grid>
            </Grid>
          )}
        </ListPlantsContainer>
      </Box>
      <Create handleClose={() => setOpenCreate(false)} open={openCreate} />
      <Edit
        handleClose={() => setEditItem(null)}
        open={editItem ? true : false}
        plant={editItem}
      />
    </>
  );
};

export default InstallerView;
